export default "__VITE_ASSET__BrSOsSr4__"